export default __webpack_public_path__ + "static/media/folder.6e4a20f6.svg";